import api from '@/API';
import { UserClient } from '@/type';
import eventBus from '@/messaging/event-bus';
import { prepareKeyword, matchesUser } from '@/user/user-search';
import {
  ClientStarred, ClientUnstarred, UserAssignedToClient, UserUnassignedFromClient,
} from '@/messaging/events';

export function star(userId: number, clientId: number): Promise<UserClient> {
  return api
    .post(`users/${userId}/clients/${clientId}/star`)
    .then((response) => {
      eventBus.$emit(ClientStarred.eventName, response.data);
      return response.data;
    });
}

export function unstar(userId: number, clientId: number): Promise<UserClient> {
  return api
    .delete(`users/${userId}/clients/${clientId}/star`)
    .then((response) => {
      eventBus.$emit(ClientUnstarred.eventName, response.data);
      return response.data;
    });
}

export function assign(userId: number, clientId: number): Promise<UserClient> {
  return api
    .post(`users/${userId}/clients/${clientId}`)
    .then((response) => {
      const userClient = (response.data as UserClient);
      eventBus.$emit(
        UserAssignedToClient.eventName,
        new UserAssignedToClient(userClient),
      );
      return userClient;
    });
}

export function unassign(userClient: UserClient): Promise<void> {
  return api
    .delete(`/user-clients/${userClient.id}`)
    .then(() => {
      eventBus.$emit(
        UserUnassignedFromClient.eventName,
        new UserUnassignedFromClient(userClient),
      );
    });
}

export function unassignAll(userClients: UserClient[]): Promise<void[]> {
  const tasks: Promise<void>[] = [];
  userClients.forEach((uc) => {
    tasks.push(unassign(uc));
  });
  return Promise.all(tasks);
}

export function assignAll(userId: number, clientIds: number[]): Promise<UserClient[]> {
  return api
    .post(`users/${userId}/clients`, { clientIds })
    .then((response) => {
      const userClients = (response.data as UserClient[]);
      userClients.forEach((uc) => {
        eventBus.$emit(
          UserAssignedToClient.eventName,
          new UserAssignedToClient(uc),
        );
      });
      return userClients;
    });
}

export function filter(keyword: string|null, userClients: UserClient[]): UserClient[] {
  const kw = prepareKeyword(keyword);
  if (kw.raw === '') return userClients;
  return userClients.filter(uc => matchesUser(uc.user, kw));
}
